module.exports = __webpack_public_path__ + "img/lucio.86f7e3fd.png";